const monthDiff = (d1x, d2x) => {
  var months;
  const d1 = new Date(d1x),
    d2 = new Date(d2x);
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};

const calculateAvgYearlyInterest = (data = {}) => {
  if (data.accountType === "deposit") {
    const months = monthDiff(data.openingDate, data.endingDate);
    const period = months / 12;
    return data.interestRate / period;
  } else {
    const map = {
      monthly: 12,
      daily: 365,
    };

    return data.interestRate * map[data.interestPeriod];
  }
};

const getInterestRateFromYearly = (data = {}) => {
  if (data.accountType === "deposit") {
    const months = monthDiff(data.openingDate, data.endingDate);
    const period = months / 12;
    return data.interestRate * period;
  } else {
    const map = {
      monthly: 12,
      daily: 365,
    };

    return data.interestRate / map[data.interestPeriod];
  }
};

const interestModule = {
  calculateAvgYearlyInterest,
  getInterestRateFromYearly,
};

export default interestModule;
